import store from "@/store";
import appSettings from "@/mixins/config/appSettings";

export const WORK_STATE_START = 'START';
export const WORK_STATE_STOP = 'STOP';
export const WORK_STATE_IDLE = 'IDLE';
export const ENTRY_DATA_KEY = 'entry_data';

    export const LMRADataObjectHelper = {
    async buildBaseLmraDataObject(){

        let dataObject = {}
        dataObject['work_session'] = await this.buildSessionData();
        dataObject[ENTRY_DATA_KEY] = {
            user_location : JSON.stringify(store.getters.getUserCurrentLocation),
        }
        return dataObject;

    },
    async buildSessionData(){
        let data = {}

        let ws = await store.getters.getActiveWorkSession;
        if(ws && (ws.session_key != null &&  ws.session_key != undefined)){
            data['session_key'] = ws.session_key;
        }else{
            data['new_session_data'] = await this.getFilteredSessionData()
        }
        return data
    },
    async getFilteredSessionData(){
        let filteredData = {}
        let currentCapSettings = await store.getters.currentClientProjectSettings;
        if(currentCapSettings){
            //CLIENT
            filteredData['client'] = {
                id : currentCapSettings.client.id,
                name : currentCapSettings.client.name
            }
            //PROJECT
            filteredData['project'] = {
                id : currentCapSettings.project.id,
                name : currentCapSettings.project.name
            }
            filteredData['project_distance'] = (!appSettings.data().appSettings.usesProjectWorkDistance || currentCapSettings.project_distance.length <= 0)? null : currentCapSettings.project_distance;
            filteredData['project_shift'] = (!appSettings.data().appSettings.usesProjectWorkShift || currentCapSettings.project_shift.length <= 0)? null : currentCapSettings.project_shift;
            filteredData['tag_code'] = (!appSettings.data().appSettings.usesCAPTagCodeScanner || currentCapSettings.project_tag_code.length <= 0)? null : currentCapSettings.project_tag_code;
            filteredData['user_language'] = store.getters.getUserLanguage;
        }

        return filteredData;
    }
}